import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEmployeeEmails } from 'Shared/actions/Employees.actions';

//Hooks
import { useCurrentUser } from './use-current-user';

//Selectors
import { getAllEmployeesEmail } from 'Shared/selectors/Employees.selectors';

//Hooks
import { useToggle } from '../hooks';

const useFetchEmployeeEmails = () => {
  const { isLoggedIn, isPiUser } = useCurrentUser();
  const [isFetching, toggleIsFetching] = useToggle(true);
  //Get the list of Employees from selector
  const employeeEmails = useSelector(state => getAllEmployeesEmail(state));
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoggedIn && isPiUser) {
      dispatch(getEmployeeEmails()).finally(() => {
        toggleIsFetching();
      });
    }
  }, [isLoggedIn, isPiUser]);

  return { isFetching, employeeEmails };
};

export default useFetchEmployeeEmails;
